import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Loader } from '../styles';
import Spinner from '../Spinner';

export enum ProcessingLoaderType {
	COMBINING = 'COMBINING',
	PDF_PROCESSING = 'PDF_PROCESSING',
	PUBLISHING_OR_UPDATING = 'PUBLISHING_OR_UPDATING',
}

interface ProcessingLoaderProps {
	type: ProcessingLoaderType;
	percentage: number;
}

const getLabel = (type: ProcessingLoaderType): string => {
	switch (type) {
		case ProcessingLoaderType.COMBINING:
			return 'messages.combining';
		case ProcessingLoaderType.PDF_PROCESSING:
			return 'messages.pdf_processing';
		case ProcessingLoaderType.PUBLISHING_OR_UPDATING:
			return '';
		default:
			return 'messages.loading';
	}
};

const ProcessingLoader = ({ type, percentage }: ProcessingLoaderProps) => {
	if (type === ProcessingLoaderType.PUBLISHING_OR_UPDATING) {
		return <Loader isProcessing={true} />;
	}

	return (
		<Loader isProcessing={true}>
			<Spinner />
			<Translate
				value={getLabel(type)}
				percentage={percentage.toString()}
			/>
		</Loader>
	);
};

export default ProcessingLoader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ProcessingLoader/index.tsx